import { IFilter } from 'types/common'
import { IProcess } from 'interfaces/process'

export const stepIncludes = [
  {
    relation: 'textContents',
    scope: {
      order: 'position ASC',
      include: [
        {
          relation: 'decisionPoints',
          scope: {
            include: [
              {
                relation: 'decisionPointMedias',
                scope: {
                  include: [
                    {
                      relation: 'media'
                    }
                  ]
                }
              },
              {
                relation: 'decisionPointSteps',
                scope: {
                  include: [
                    {
                      relation: 'step'
                    }
                  ]
                }
              }
            ],
            order: ['position ASC']
          }
        },
        {
          relation: 'icon'
        },
        {
          relation: 'textContentMedias',
          scope: {
            include: [
              {
                relation: 'media'
              }
            ]
          }
        },
        {
          relation: 'media'
        }
      ]
    }
  },
  {
    relation: 'media',
    scope: {
      order: 'createdAt ASC'
    }
  },
  {
    relation: 'icon'
  },
  // Drill authoring content (HF-1465). Both are registered inclusion resolvers on
  // StepRepository, so pulling them here gives the Stack Detail drill list its
  // per-drill counts and the inspector its lists without a request per drill.
  {
    relation: 'requirements',
    scope: {
      order: 'position ASC'
    }
  },
  {
    relation: 'resources',
    scope: {
      order: 'position ASC'
    }
  }
]

export function getProcessFilter(): IFilter<IProcess> {
  const stepFilter = {
    include: [
      ...stepIncludes,
      {
        relation: 'originalStep',
        scope: {
          include: [...stepIncludes],
          order: 'position ASC'
        }
      },
      {
        relation: 'commonLibrary'
      }
    ],
    order: 'position ASC'
  }

  const filter: IFilter<IProcess> = {
    include: [
      {
        relation: 'steps',
        scope: {
          ...stepFilter
        }
      },
      {
        relation: 'media',
        scope: {
          order: 'createdAt ASC'
        }
      },
      {
        relation: 'collections',
        scope: {
          where: {
            archivedAt: { inq: [undefined, null] }
          }
        }
      },
      {
        relation: 'collection'
      },
      {
        // Plain groups only: the old nested members→member include pointed at a
        // relation removed in the membership-key migration (GroupMember now has
        // orgMembership, not a User `member`), so the BE rejected the whole
        // detail request with Invalid "filter.include" — and nothing on the
        // detail page reads groups.members anyway.
        relation: 'groups'
      },
      {
        relation: 'tags'
      },
      {
        relation: 'creator'
      },
      {
        relation: 'collaborators'
      },
      {
        // The same rows, unresolved. `collaborators` are Users and carry no
        // OrgMembership id, which is the only identity the Stack capabilities
        // read; the Edit collaborators form still needs the Users.
        relation: 'collaborations'
      },
      {
        relation: 'userProcesses',
        scope: {
          include: [
            {
              relation: 'user'
            }
          ]
        }
      }
    ]
  }
  return filter
}
